import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Toast } from 'antd-mobile';
import { Link } from 'react-router-dom';
import Http from '../../config/axiosUtils';
import TeamItem from '../../components/team/TeamItem';
import { getStore } from '../../config/storage';

import '../../assets/scss/Income/incomeHome.scss';
import AvaterImg from '../../assets/images/income/income_money@2x.png';

class IncomeHome extends Component {
  state = {
    allIncomeData: {},
    customerData: {},
    teamData: {},
    registerData: {},
    quotaData: {},
    withdrawData: {},
    stageData: {},
    hasGroup: false
  }

  componentDidMount() {
    if (getStore('teamLevel') === 1 || getStore('teamLevel') === 2) {
      this.setState({
        hasGroup: true
      })
    }
    this.fetchData();
  }

  fetchData = async () => {
    const path = '/spread/web/income/info';
    const res = await Http.get(path);
    if (res.code === 0) {
      this.setState({
        allIncomeData: res.data.allIncomeData,
        customerData: res.data.customerIncomeData,
        teamData: res.data.teamIncomeData,
        registerData: res.data.registerData,
        quotaData: res.data.quotaData,
        withdrawData: res.data.withdrawData,
        stageData: res.data.stageData
      });
    } else {
      Toast.fail(res.msg, 2);
    }
  }

  render () {
    const { allIncomeData, customerData, teamData, registerData, quotaData, withdrawData, stageData } = this.state;
    const customIncome = [
      { name: '累计客户收益', value: customerData.allAmount },
      { name: '当月客户收益', value: customerData.monthAmount },
      { name: '今日客户收益', value: customerData.todayAmount },
    ];
    let groupIncome;
    if (teamData !== null) {
      groupIncome = [
        { name: '累计团队收益', value: teamData.allAmount },
        { name: '当月团队收益', value: teamData.monthAmount },
        { name: '今日团队收益', value: teamData.todayAmount },
      ];
    }
    return (
      <div>
        <Helmet><title>我的收益</title></Helmet>
        <div className='incomeHome teamHome'>
          <div className='team-top'>
            <div className='top-main'>
              <div className='top-main-avater'><img src={AvaterImg} alt='' /></div>
              <div className='top-main-info'>
                <div className='team-titleAll'>累计总收益(元)</div>
                <div className='team-num'>{allIncomeData.allAmount}</div>
              </div>
            </div>
            <div className='top-detail'>
              <ul>
                <li>
                  <div>当月收益</div>
                  <div>{allIncomeData.monthAmount}</div>
                </li>
                <li>
                  <div>今日收益</div>
                  <div>{allIncomeData.todayAmount}</div>
                </li>
              </ul>
            </div>
            <Link to='/incomeDetail'>
              <div className='team-right'>
                <i className='iconfont icon-kehuliebiao'></i>收益明细
              </div>
            </Link>
          </div>
          <div className='group-content'>
            <div className='content-bg' style={{backgroundImage: 'none', backgroundColor: '#f5f5f5'}}>
              <div className='content-top'>收益总览(元)</div>
            </div>
            <div className='income-list'>
              <ul>
                {
                  customIncome.map((item, index) => {
                    return (
                      <li key={index}>
                        <div>{item.name}</div>
                        <div>{item.value}</div>
                      </li>
                    )
                  })
                }
              </ul>
              {this.state.hasGroup && <ul>
                {
                  groupIncome.map((item, index) => {
                    return (
                      <li key={index}>
                        <div>{item.name}</div>
                        <div>{item.value}</div>
                      </li>
                    )
                  })
                }
              </ul>}
            </div>
            <div className='content-detail' style={{paddingTop: '0'}}>
              <div className='income-item content-item'>
                <div className='item-title'>
                  <i className='iconfont icon-zhucekehu'></i>注册收益(元)
                </div>
                <TeamItem
                  isIncomeAmount
                  keyArr={['累计注册收益', '当月注册收益', '今日注册收益']}
                  itemObj={registerData}>
                </TeamItem>
              </div>
              <div className='income-item content-item'>
                <div className='item-title'>
                  <i className='iconfont icon-huoekehu'></i>获额收益(元)
                </div>
                <TeamItem
                  isIncomeAmount
                  keyArr={['累计获额收益', '当月获额收益', '今日获额收益']}
                  itemObj={quotaData}>
                </TeamItem>
              </div>
              <div className='content-item'>
                <div className='item-title'>
                  <i className='iconfont icon-tixianshouyi'></i>提现收益(元)
                </div>
                <TeamItem
                  isAmount
                  keyArr={['累计提现收益', '当月提现收益']}
                  itemObj={withdrawData}>
                </TeamItem>
              </div>
              <div className='content-item'>
                <div className='item-title'>
                  <i className='iconfont icon-fenqijine'></i>分期收益(元)
                </div>
                <TeamItem
                  isAmount
                  keyArr={['累计分期收益', '当月分期收益']}
                  itemObj={stageData}>
                </TeamItem>
              </div>
              {/* <div className='income-item content-item'>
                <div className='item-title'>
                  <i className='iconfont icon-huodongshouyi'></i>活动收益(元)
                </div>
                <TeamItem
                  isIncomeAmount
                  keyArr={['累计活动收益', '当月活动收益', '今日活动收益']}
                  itemObj={registerData}>
                </TeamItem>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default IncomeHome;